
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
  export default class CPSubmitIndicator extends Vue {

    @Prop({ required: false })
    public text!: string;
    @Prop({ required: false })
    public textLine2?: string;


  }
